import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { faker } from '@faker-js/faker';
// @mui
import { useTheme, styled } from '@mui/material/styles';
import { Grid, Container, Typography, Tabs, Tab } from '@mui/material';
// components
import FavoriteIcon from '@mui/icons-material/Favorite';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import PhoneMissedIcon from '@mui/icons-material/PhoneMissed';
import PhoneIcon from '@mui/icons-material/Phone';
import SatelliteIcon from '@mui/icons-material/Satellite';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import StreetviewIcon from '@mui/icons-material/Streetview';
import StoreMallDirectoryIcon from '@mui/icons-material/StoreMallDirectory';
import { Warning } from '@mui/icons-material';
import { HomeFilled, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import BaseColor from '../BaseColor';
// sections
import {
  AppTasks,
  AppNewsUpdate,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppWidgetSummary,
  AppCurrentSubject,
  AppConversionRates,
} from '../sections/@dashboard/app';
import UserPage from './UserPage';
import apiFunctions from '../API/api';

import Iconify from '../components/iconify'; // --- > This should be imported last < --- //
import StorePage from './StorePage';
import LocationPage from './LocationPage';
import { useFilter } from '../layouts/dashboard/FilterProvider';
import DownloadReport from './DownloadReport';
// ----------------------------------------------------------------------
// Styled components should be defined after all regular imports
const StyledTabs = styled(Tabs)(({ theme }) => ({
  overflow: 'hidden',
  '& .MuiTabs-flexContainer': {
    width: '100%',
    justifyContent: 'space-evenly',
    backgroundColor: 'pink',
    borderRadius: '1rem',
    flexWrap: 'wrap', // Set flex-wrap to 'wrap' for larger screens
    overflowX: 'auto',
    scrollbarWidth: 'none',
    '-ms-overflow-style': 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'nowrap', // Set flex-wrap to 'nowrap' for smaller screens
      maxWidth: '100%', // Add this to limit the maximum width
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'nowrap', // Set flex-wrap to 'nowrap' for smaller screens
      maxWidth: '80%', // Add this to limit the maximum width
    },
  },
  '& .Mui-selected': {
    borderBottom: `2px solid ${BaseColor}`, // Change the color and width of the active indicator here
    minWidth: '50px', // Set the width of the active indicator to match tab minWidth
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  flex: '0 0 auto',
  // minWidth: '50px', // Default width for larger screens and active indicator
  color: '#cd4269',
  fontSize: '1rem',
  '&.Mui-selected': {
    color: '#cd4269',
  },
  '&:hover': {
    color: '#cd4269',
  },

  // Responsive tab sizing
  [theme.breakpoints.down('sm')]: {
    // minWidth: '150px', // Adjust tab width for small screens (e.g., tablets)
    fontSize: '0.9rem', // Adjust font size for small screens
    padding: '0',
    margin: '0',
    width: '33%',
  },
  [theme.breakpoints.down('xs')]: {
    minWidth: '20px', // Further reduce tab width for phones
    fontSize: '0.8rem', // Further reduce font size for phones
    width: 'max-content',
    padding: '0',
    margin: '0',
  },
}));
export default function DashboardAppPage() {
  const { filter } = useFilter();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const [count, setCount] = useState([]);
  const [date, setDate] = useState([]);
  const [totalGV, setTotalGV] = useState(0);
  const [usedGV, setUsedGV] = useState(0);

  const [store, setStore] = useState([]);
  const [storeValue, setStoreValue] = useState([]);

  const [storeCode, setStoreCode] = useState([]);

  const [storeBar, setStoreBar] = useState([]);
  const [storeBarValue, setStoreBarValue] = useState([]);
  const [storeTable, setStoreTable] = useState([]);

  const [location, setLocation] = useState([]);
  const [locationCount, setLocationCount] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [locationLabel, setLocationLabel] = useState([]);
  const [chartDataLoc, setChartDataLoc] = useState([]);

  const currentYear = new Date().getFullYear();
  const nav = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token === '' || token === 'undefined' || token === undefined || token === null) {
      nav('/login');
    }
  }, []);
  useEffect(() => {
    async function getUsers() {
      function formatDate(dateString) {
        const options = { month: 'numeric', day: '2-digit', year: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString(undefined, options);
      }
      try {
        const data = await apiFunctions.getUserCounts(filter);
        const dates = Object.keys(data);
        const counts = Object.values(data);
        const formattedDates = dates.map((date) => new Date(date));

        // Format each date string in the array
        const FinalDate = formattedDates.map(formatDate);
        FinalDate.sort((a, b) => {
          const dateA = new Date(a);
          const dateB = new Date(b);
          return dateA - dateB;
        });
        setCount(counts);
        setDate(FinalDate);
      } catch (error) {
        console.error('Error fetching user counts:', error);
        // Handle error if needed
      }
    }
    async function getGV() {
      try {
        const data = await apiFunctions.getGVCounts(filter);
        setTotalGV(data.total);
        setUsedGV(data.used);
      } catch (error) {
        console.error('Error fetching user counts:', error);
        // Handle error if needed
      }
    }
    async function getTopFive() {
      const val = await apiFunctions.getTopTenStoreCounts(filter);
      const storeCode = [];
      const values = [];
      const storeID = [];

      // Iterate through the sorted data and extract storeID and total
      val.forEach((item) => {
        storeCode.push(item.storeName);
        values.push(item.total);
        storeID.push(item.storeCode);
      });
      setStoreBar(storeCode);
      setStoreBarValue(values);
      setStoreCode(storeID);
      const pieData = val.slice(0, 5);
      const pieName = [];
      const pieValue = [];

      // Iterate through the sorted data and extract storeID and total
      pieData.forEach((item) => {
        pieName.push(item.storeName);
        pieValue.push(item.total);
      });
      setStore(pieName);
      setStoreValue(pieValue);
    }
    async function getStoreCounts() {
      const val = await apiFunctions.getStoreCounts(filter);
      setStoreTable(val);
    }
    getStoreCounts();
    getUsers();
    getGV();
    getTopFive();
  }, [filter]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    async function prepareChartData(locationCount, location) {
      const chartData = [];
      const length = Math.min(5, locationCount.length); // Take the minimum of 5 and the array length

      for (let i = 0; i < length; i += 1) {
        chartData.push({
          value: locationCount[i],
          label: location[i],
        });
      }

      return chartData;
    }

    async function getTabelData() {
      function formatDate(dateString) {
        const options = { month: 'numeric', day: '2-digit', year: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString(undefined, options);
      }
      try {
        const data = await apiFunctions.getStoreCounts(filter);
        const location = [];
        const locationLabel = [];
        const total = [];
        // const data = result.slice(0, 10);

        const jsonArray = data.reduce((result, item) => {
          const { locations, storeCode } = item;
          Object.keys(locations).forEach((locationCode) => {
            const locationData = locations[locationCode];
            const { Location, LocationCode, Count } = locationData;
            result.push({
              location: Location,
              LocationCode,
              Count,
              storeCode,
            });
          });
          return result;
        }, []);
        const temp = jsonArray.sort((a, b) => b.Count - a.Count);
        const rresult = temp.slice(0, 10);
        // Iterate through the sorted data and extract storeID and total
        rresult.forEach((item) => {
          location.push(`${item.location} [ ${item.storeCode}]`);
          locationLabel.push(item.location);
          total.push(item.Count);
        });

        const chartData = await prepareChartData(total, location);

        setChartDataLoc(chartData);
        setLocation(location);
        setLocationCount(total);
        setLocationLabel(locationLabel);
        setLocationData(jsonArray);
      } catch (error) {
        console.error('Error fetching user counts:', error);
        // Handle error if needed
      }
    }
    getTabelData();
  }, [filter]);
  return (
    <>
      <Helmet>
        <title> MIA </title>
      </Helmet>

      <Container maxWidth="xl">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h4" sx={{ mb: 5, color: 'black' }}>
            Hi, Welcome back
          </Typography>
          <DownloadReport filter={filter} />
        </div>

        <StyledTabs value={value} onChange={handleChange} aria-label="icon position tabs example" indicatorColor="red">
          <StyledTab
            icon={<HomeFilled style={{ marginLeft: '5px' }} />}
            label="General"
            iconPosition="start"
            sx={{
              color: 'black',
              fontSize: '1rem',
            }}
          />
          <StyledTab
            icon={<StoreMallDirectoryIcon style={{ marginLeft: '5px' }} />}
            iconPosition="start"
            label="Store"
            sx={{
              color: '#cd4269',
              fontSize: '1rem',
            }}
          />
          <StyledTab
            icon={<LocationCityIcon style={{ marginLeft: '5px' }} />}
            iconPosition="end"
            label="Location"
            sx={{
              color: '#cd4269',
              fontSize: '1rem',
            }}
          />
        </StyledTabs>
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={8}>
            {value === 0 && (
              <AppWebsiteVisits
                title="Gift Vouchers"
                subheader="GV counts per day"
                chartLabels={date}
                chartData={[
                  {
                    name: 'Users',
                    type: 'area',
                    fill: 'gradient',
                    data: count,
                  },
                ]}
              />
            )}

            {value === 1 && (
              <AppWebsiteVisits
                title="Top 10 stores"
                subheader="GV counts"
                chartLabels={storeCode}
                chartData={[
                  {
                    name: 'Store',
                    type: 'column',
                    fill: 'solid',
                    data: storeBarValue,
                  },
                ]}
              />
            )}
            {value === 2 && (
              <AppWebsiteVisits
                title="Top 10 Locations"
                subheader="GV counts"
                chartLabels={location}
                toolLabel={locationLabel}
                chartData={[
                  {
                    name: 'Store',
                    type: 'column',
                    fill: 'solid',
                    data: locationCount,
                  },
                ]}
              />
            )}
          </Grid>
          <Grid item xs={12} md={6} lg={4} marginBottom={0}>
            {value === 1 && (
              <AppCurrentVisits
                title=" Traffic"
                chartData={[
                  { value: storeValue[0], label: storeBar[0] },
                  { value: storeValue[1], label: storeBar[1] },
                  { value: storeValue[2], label: storeBar[2] },
                  { value: storeValue[3], label: storeBar[3] },
                  { value: storeValue[4], label: storeBar[4] },
                ]}
                chartColors={['#DB6D7F', '#F36C8D', '#F78BA6', '#F7BCCA', '#F7ADC0']}
              />
            )}
            {value === 2 && (
              <AppCurrentVisits
                title=" Traffic"
                chartData={chartDataLoc}
                chartColors={['#DB6D7F', '#F36C8D', '#F7BCCA', '#F78BA6', '#F7ADC0']}
              />
            )}
            {value === 0 && (
              <Grid item xs={12}>
                <AppWidgetSummary
                  title={filter.type === '' ? 'Total GV Count' : 'Total customers'}
                  total={totalGV}
                  color="secondary"
                  sx={{ backgroundColor: BaseColor, color: 'white' }}
                  icon={'ant-design:shopping-filled'}
                />
              </Grid>
            )}
            {value === 0 && (
              <Grid
                item
                xs={12}
                sx={{
                  marginTop: '1rem',
                  // height: '',
                }}
              >
                <AppWidgetSummary
                  title={filter.type === '' ? 'Used GV Count' : 'Recieved customers'}
                  total={usedGV}
                  color="error"
                  sx={{ backgroundColor: 'white', color: `${BaseColor}`, boxShadow: '1px 1px 5px #ffeff1' }}
                  icon={'ant-design:carry-out-filled'}
                />
              </Grid>
            )}
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            {value === 0 && <UserPage />}
            {value === 1 && <StorePage />}
            {value === 2 && <LocationPage />}

            {/* <StorePage /> */}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
